import { MenuItemsType } from "../MenuItems/types";

export const menuConfig: MenuItemsType[] = [
  {
    label: "Home",
    href: "/",
    // icon: "Logout",
    // items: [
    //   {
    //     label: "All Games",
    //     href: "/#",
    //   },
    //   {
    //     label: "Top Games",
    //     href: "/#",
    //   },
    //   {
    //     label: "Trending Games",
    //     href: "/#",
    //     // iconName: "Chart",
    //     // isMobileOnly: true,
    //   },
    //   {
    //     label: "Premium Games",
    //     href: "/#",
    //   },
    //   {
    //     label: "Gainers & Loser",
    //     href: "/#",
    //   },
    //   {
    //     label: "Recently Added",
    //     href: "/#",
    //     // iconName: "Chart",
    //     // isMobileOnly: true,
    //   },
    // ],
  },
  {
    label: "About",
    href: "/about",
    // icon: "Logout",
    // items: [
    //   {
    //     label: "Earn",
    //     href: "/",
    //   },
    //   {
    //     label: "Yield Farms",
    //     href: "/",
    //   },
    //   {
    //     label: "Syrup pools",
    //     href: "/",
    //   },
    // ],
  },
  {
    label: "Services",
    href: "/services/web&dev",
    // icon: "Logout",
    // items: [
    //   {
    //     label: "Win",
    //     href: "/",
    //   },
    //   {
    //     label: "Predictions",
    //     href: "/",
    //     // status: status.SOON,
    //   },
    //   {
    //     label: "Lottery",
    //     href: "/",
    //   },
    // ],
  },
  {
    label: "Blockchain",
    href: "/how-it-works",
    // icon: "Logo",
    // items: [
    //   {
    //     label: "Overview",
    //     href: "/",
    //   },
    //   {
    //     label: "Collections",
    //     href: "/",
    //     // status: status.LIVE,
    //   },
    //   {
    //     label: "Activity",
    //     href: "/",
    //   },
    // ],
  },

  {
    label: "Contact Us",
    href: "/contact-us",
    // icon: "Logo",
    // items: [
    //   {
    //     label: "Overview",
    //     href: "/",
    //   },
    //   {
    //     label: "Collections",
    //     href: "/",
    //     // status: status.LIVE,
    //   },
    //   {
    //     label: "Activity",
    //     href: "/",
    //   },
    // ],
  },
];

